<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  interface Props {
    value: string;
    placeholder?: string;
    maxlength?: number;
    disabled?: boolean;
    ariaLabel?: string;
    invalid?: boolean;
    onInput?: (value: string) => void;
    onEnter?: () => void;
  }

  let {
    value = $bindable(''),
    placeholder,
    maxlength,
    disabled = false,
    ariaLabel,
    invalid = false,
    onInput,
    onEnter,
  }: Props = $props();

  function handleKey(e: KeyboardEvent) {
    if (e.key === 'Enter') onEnter?.();
  }
</script>

<input
  {placeholder}
  {maxlength}
  {disabled}
  aria-label={ariaLabel}
  aria-invalid={invalid}
  bind:value
  oninput={(e) => onInput?.((e.target as HTMLInputElement).value)}
  onkeydown={handleKey}
  class="w-full bg-slate-800/50 border rounded-xl px-4 py-3 text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 transition {invalid
    ? 'border-red-500/50 focus:border-red-400 focus:ring-red-400/20'
    : 'border-white/10 focus:border-indigo-400 focus:ring-indigo-400/20'}"
/>
